<template>
    <div class="tabs-container">
        <slot></slot>
    </div>
</template>
<script>
export default {

    props: {
        target: {
            type: String,
            required: true,
        },
        trackState: {
            type: Boolean,
            default: true,
        }
    },

    mounted() {
        window.addEventListener("hashchange", (event) => {
            // console.log(event)
        }, false);

        if (this.trackState) {
            $(`#${this.target} a[href="${window.location.hash}"]`).tab('show')
        }

        $(`#${this.target} a[data-toggle="tab"]`).on('shown.bs.tab', event => {
            if (this.trackState) {
                history.pushState({}, '', event.target.href)
            }
            this.refreshTooltips();
            this.$emit('tap', event.currentTarget.hash)
        })
    },
}
</script>
